export const CommonLabelStyles = `
  font-family: 'TT Commons Pro';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.02em;
`;
